<div class="payment-result-page">

  <div class="payment-result-card">

    <div class="failed-icon">
      ×
    </div>

    <div class="brand">
      Smee<span>&amp;</span>Ford
    </div>

    <div class="red-line"></div>

    <h1>Payment not completed</h1>

    <p class="intro">
      Your PAYG payment was not completed.
    </p>

    <div class="message-box">
      <p>
        No payment has been confirmed for this notification.
      </p>

      <p>
        You can return to the PAYG page and try again if you
        would still like to access the notification.
      </p>
    </div>

    <button mat-raised-button
            color="primary"
            class="continue-button"
            (click)="tryAgain()">
      Return to PAYG
    </button>

    <p class="help-text">
      If you believe you were charged but see this message,
      please contact the Smee &amp; Ford customer-services team.
    </p>

  </div>

</div>
